import { useEffect, useState } from "react";
import ReactPaginate from 'react-paginate';
import './PaginationComponent.css'; // Add your own styling

export default function PaginationComponent(props) {
  const [total_pages, setTotalPages] = useState(0);
  const {
    total_count,
    current_page,
    handleOnClick,
    per_page = 25
  } = props;

  useEffect(() => {
    const pages = Math.ceil(total_count / per_page);
    setTotalPages(pages);
  }, [total_count, per_page]);

  const handlePageClick = (event) => {
    handleOnClick(event.selected + 1); // react-paginate uses 0-based indexing
  };

  return (
    total_pages > 1 && (
      <ReactPaginate
        breakLabel="..."
        nextLabel="Next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={total_pages}
        forcePage={current_page - 1} // Convert to 0-based
        previousLabel="< Previous"
        renderOnZeroPageCount={null}
        className="pagination-container"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
      />
    )
  );
}